import { render, staticRenderFns } from "./AssignOrganizationModal.vue?vue&type=template&id=0d519979&scoped=true"
import script from "./AssignOrganizationModal.vue?vue&type=script&lang=js"
export * from "./AssignOrganizationModal.vue?vue&type=script&lang=js"
import style0 from "./AssignOrganizationModal.vue?vue&type=style&index=0&id=0d519979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d519979",
  null
  
)

export default component.exports